// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file knop/ui/v1/model/action.proto (package knop.ui.v1.model, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from message knop.ui.v1.model.Action
 */
export class Action extends Message<Action> {
  /**
   * An action can either be a movement or a track action.
   *
   * @generated from oneof knop.ui.v1.model.Action.action
   */
  action: {
    /**
     * @generated from field: knop.ui.v1.model.Action.MovementAction movement = 1;
     */
    value: Action_MovementAction;
    case: "movement";
  } | {
    /**
     * @generated from field: knop.ui.v1.model.Action.TrackAction track_action = 2;
     */
    value: Action_TrackAction;
    case: "trackAction";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<Action>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.model.Action";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "movement", kind: "message", T: Action_MovementAction, oneof: "action" },
    { no: 2, name: "track_action", kind: "message", T: Action_TrackAction, oneof: "action" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Action {
    return new Action().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Action {
    return new Action().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Action {
    return new Action().fromJsonString(jsonString, options);
  }

  static equals(a: Action | PlainMessage<Action> | undefined, b: Action | PlainMessage<Action> | undefined): boolean {
    return proto3.util.equals(Action, a, b);
  }
}

/**
 * @generated from enum knop.ui.v1.model.Action.Changeability
 */
export enum Action_Changeability {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: FIXED = 1;
   */
  FIXED = 1,

  /**
   * @generated from enum value: PINNED = 2;
   */
  PINNED = 2,

  /**
   * @generated from enum value: OPEN = 3;
   */
  OPEN = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(Action_Changeability)
proto3.util.setEnumType(Action_Changeability, "knop.ui.v1.model.Action.Changeability", [
  { no: 0, name: "UNKNOWN" },
  { no: 1, name: "FIXED" },
  { no: 2, name: "PINNED" },
  { no: 3, name: "OPEN" },
]);

/**
 * @generated from enum knop.ui.v1.model.Action.Orientation
 */
export enum Action_Orientation {
  /**
   * @generated from enum value: ORIENTATION_UNKNOWN = 0;
   */
  ORIENTATION_UNKNOWN = 0,

  /**
   * @generated from enum value: FIRST_UNIT_ON_TARGET_SIDE = 1;
   */
  FIRST_UNIT_ON_TARGET_SIDE = 1,

  /**
   * @generated from enum value: FIRST_UNIT_ON_SOURCE_SIDE = 2;
   */
  FIRST_UNIT_ON_SOURCE_SIDE = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(Action_Orientation)
proto3.util.setEnumType(Action_Orientation, "knop.ui.v1.model.Action.Orientation", [
  { no: 0, name: "ORIENTATION_UNKNOWN" },
  { no: 1, name: "FIRST_UNIT_ON_TARGET_SIDE" },
  { no: 2, name: "FIRST_UNIT_ON_SOURCE_SIDE" },
]);

/**
 * @generated from message knop.ui.v1.model.Action.MovementAction
 */
export class Action_MovementAction extends Message<Action_MovementAction> {
  /**
   * @generated from field: string guid = 1;
   */
  guid = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 3;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 4;
   */
  endTime?: Timestamp;

  /**
   * @generated from field: string action_type = 5;
   */
  actionType = "";

  /**
   * @generated from field: knop.ui.v1.model.Action.Changeability changeability = 6;
   */
  changeability = Action_Changeability.UNKNOWN;

  /**
   * @generated from field: repeated string tracks = 7;
   */
  tracks: string[] = [];

  /**
   * @generated from field: knop.ui.v1.model.Action.Orientation orientation = 8;
   */
  orientation = Action_Orientation.ORIENTATION_UNKNOWN;

  /**
   * @generated from field: int32 distance_to_source_in_mm_start = 9;
   */
  distanceToSourceInMmStart = 0;

  /**
   * @generated from field: int32 distance_to_source_in_mm_end = 10;
   */
  distanceToSourceInMmEnd = 0;

  /**
   * @generated from field: string shunting_unit_guid = 11;
   */
  shuntingUnitGuid = "";

  /**
   * @generated from field: string stabling_infra_start = 12;
   */
  stablingInfraStart = "";

  /**
   * @generated from field: string stabling_infra_end = 13;
   */
  stablingInfraEnd = "";

  constructor(data?: PartialMessage<Action_MovementAction>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.model.Action.MovementAction";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "guid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "start_time", kind: "message", T: Timestamp },
    { no: 4, name: "end_time", kind: "message", T: Timestamp },
    { no: 5, name: "action_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "changeability", kind: "enum", T: proto3.getEnumType(Action_Changeability) },
    { no: 7, name: "tracks", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "orientation", kind: "enum", T: proto3.getEnumType(Action_Orientation) },
    { no: 9, name: "distance_to_source_in_mm_start", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "distance_to_source_in_mm_end", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "shunting_unit_guid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "stabling_infra_start", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "stabling_infra_end", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Action_MovementAction {
    return new Action_MovementAction().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Action_MovementAction {
    return new Action_MovementAction().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Action_MovementAction {
    return new Action_MovementAction().fromJsonString(jsonString, options);
  }

  static equals(a: Action_MovementAction | PlainMessage<Action_MovementAction> | undefined, b: Action_MovementAction | PlainMessage<Action_MovementAction> | undefined): boolean {
    return proto3.util.equals(Action_MovementAction, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.model.Action.TrackAction
 */
export class Action_TrackAction extends Message<Action_TrackAction> {
  /**
   * @generated from field: string guid = 1;
   */
  guid = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 3;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 4;
   */
  endTime?: Timestamp;

  /**
   * @generated from field: string action_type = 5;
   */
  actionType = "";

  /**
   * @generated from field: knop.ui.v1.model.Action.Changeability changeability = 6;
   */
  changeability = Action_Changeability.UNKNOWN;

  /**
   * @generated from field: knop.ui.v1.model.Action.Orientation orientation = 8;
   */
  orientation = Action_Orientation.ORIENTATION_UNKNOWN;

  /**
   * @generated from field: int32 distance_to_source_in_mm = 9;
   */
  distanceToSourceInMm = 0;

  /**
   * @generated from field: string shunting_unit_guid = 10;
   */
  shuntingUnitGuid = "";

  /**
   * @generated from field: string stabling_infra = 11;
   */
  stablingInfra = "";

  constructor(data?: PartialMessage<Action_TrackAction>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.model.Action.TrackAction";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "guid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "start_time", kind: "message", T: Timestamp },
    { no: 4, name: "end_time", kind: "message", T: Timestamp },
    { no: 5, name: "action_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "changeability", kind: "enum", T: proto3.getEnumType(Action_Changeability) },
    { no: 8, name: "orientation", kind: "enum", T: proto3.getEnumType(Action_Orientation) },
    { no: 9, name: "distance_to_source_in_mm", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "shunting_unit_guid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "stabling_infra", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Action_TrackAction {
    return new Action_TrackAction().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Action_TrackAction {
    return new Action_TrackAction().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Action_TrackAction {
    return new Action_TrackAction().fromJsonString(jsonString, options);
  }

  static equals(a: Action_TrackAction | PlainMessage<Action_TrackAction> | undefined, b: Action_TrackAction | PlainMessage<Action_TrackAction> | undefined): boolean {
    return proto3.util.equals(Action_TrackAction, a, b);
  }
}

